import { DELETE_MEASUREMENT_ERROR, DELETE_MEASUREMENT_INIT, DELETE_MEASUREMENT_REQUEST, DELETE_MEASUREMENT_SUCCESS } from '../actions/MeasurementActions'

const initialState = {
	deleteMeasurements: {}
}

const MeasurementReducer = function (state = initialState, action) {
	switch (action.type) {
		case DELETE_MEASUREMENT_INIT: {
			return {
				...state,
				deleteMeasurements: initialState.deleteMeasurements
			}
		}
		case DELETE_MEASUREMENT_REQUEST: {
			return {
				...state,
				deleteMeasurements: { loading: true }
			}
		}
		case DELETE_MEASUREMENT_SUCCESS: {
			return {
				...state,
				deleteMeasurements: {
					loading: false,
					data: action.payload.data,
					success: true
				}
			}
		}
		case DELETE_MEASUREMENT_ERROR: {
			return {
				...state,
				deleteMeasurements: {
					loading: false,
					error: action.payload.error
				}
			}
		}
		default: {
			return {
				...state
			}
		}
	}
}

export default MeasurementReducer
